<template>
  <div id="login">
    <div class="main-container" style="background: var(--default)">
      <!-- Header -->
      <div class="header bg-gradient-primary py-7 py-lg-8">
        <div class="container">
          <div class="header-body text-center mb-7">
            <div class="row justify-content-center">
              <div class="col-lg-5 col-md-6">
                <h1 class="text-white">{{ $i18n.t('login.title') }}</h1>
                <p class="text-lead text-light">{{ $i18n.t('login.subtitle') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="separator separator-bottom separator-skew zindex-100">
          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </div>
      <!-- Page content -->
      <div class="container mt--8 pb-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8">

            <div class="card bg-secondary shadow border-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                  <small>{{ $i18n.t('register.text') }}</small>
                </div>
                <div>
                  <div class="form-group">
                    <div class="input-group input-group-alternative mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-hat-3"></i></span>
                      </div>
                      <input class="form-control" v-model="displayName" :placeholder="$i18n.t('register.displayName')" type="text">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group input-group-alternative mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                      </div>
                      <input class="form-control" v-model="email" :placeholder="$i18n.t('register.email')" type="email">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                      </div>
                      <input class="form-control" v-model="password" :placeholder="$i18n.t('register.password')" type="password">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group input-group-alternative">
                      <div class="dropdown full-width">
                        <button class="btn btn-secondary dropdown-toggle full-width bg-white" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span v-if="photoURL">
                            <i class="far fa-thumbs-up"></i>
                          </span>
                          <span v-else>
                            {{ $i18n.t('register.choose_image') }}
                          </span>
                        </button>
                        <div class="dropdown-menu full-width" aria-labelledby="dropdownMenuButton">
                          <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                            <img class="full-width" src="https://images.unsplash.com/photo-1524673450801-b5aa9b621b76?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80" alt="Image">
                          </a>
                          <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                            <img class="full-width" src="https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80" alt="Image">
                          </a>
                          <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                            <img class="full-width" src="https://images.unsplash.com/photo-1533094700036-70ecccc6f047?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=850&q=80" alt="Image">
                          </a>
                          <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                            <img class="full-width" src="https://images.unsplash.com/photo-1526913299589-f35a3ddeb7ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="Image">
                          </a>
                          <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                            <img class="full-width" src="https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="Image">
                          </a>
                          <a @click.prevent="selectPhotoURL('https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80')" class="dropdown-item full-width" href="#">
                            <img class="full-width" src="https://images.unsplash.com/photo-1524673278499-6c651bf78b14?ixlib=rb-1.2.1&auto=format&fit=crop&w=850&q=80" alt="Image">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button @click.prevent="register()" class="btn btn-primary mt-4">{{ $i18n.t('register.create_account') }}</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <a href="#" @click.prevent="$router.replace({ name: 'login' })" class="text-light"><small>{{ $i18n.t('register.back') }}</small></a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      displayName: null,
      photoURL: null,
      email: null,
      password: null,
      error: null,
      loading: false
    }
  },
  mounted () {
    this.$store.dispatch('checkUserStatus')
  },
  computed: {
    isLogged () {
      let user = this.$store.getters.user || localStorage.getItem('user')
      if (user) {
        this.$emit('authenticated', true)
        this.$router.replace({ name: 'home' })
      }
      return user
    },
    haveError () {
      return this.$store.getters.error
    }
  },
  watch: {
    haveError (value) {
      this.loading = false
      this.error = value
    },
    isLogged (value) {
      // console.log('LOGIN isLogged', value)
    }
  },
  methods: {
    selectPhotoURL (photoURL) {
      this.photoURL = photoURL
    },
    register () {
      if (this.displayName && this.email && this.password && this.photoURL) {
        this.loading = true
        this.$store.dispatch('userRegister', {
          email: this.email,
          password: this.password,
          displayName: this.displayName,
          photoURL: this.photoURL
        })
      }
    }
  }
}
</script>

<style scoped>
  .dropdown-toggle::after { display: none; }
  .dropdown-menu {
    height: 300px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/Register.vue